import { COUNTRY_CODES } from 'swag-common/constants/shipping.constants';
export let SHIPOUT_CSV_KEYS = /*#__PURE__*/function (SHIPOUT_CSV_KEYS) {
  SHIPOUT_CSV_KEYS["FIRST_NAME"] = "firstName";
  SHIPOUT_CSV_KEYS["LAST_NAME"] = "lastName";
  SHIPOUT_CSV_KEYS["EMAIL"] = "email";
  SHIPOUT_CSV_KEYS["COUNTRY"] = "country";
  SHIPOUT_CSV_KEYS["STATE"] = "state";
  SHIPOUT_CSV_KEYS["CITY"] = "city";
  SHIPOUT_CSV_KEYS["ADDRESS"] = "address";
  SHIPOUT_CSV_KEYS["UNIT"] = "unit";
  SHIPOUT_CSV_KEYS["ZIP"] = "zip";
  SHIPOUT_CSV_KEYS["PHONE"] = "phone";
  return SHIPOUT_CSV_KEYS;
}({});
export const SHIPOUT_CSV_KEYS_SEQUENCE = [SHIPOUT_CSV_KEYS.FIRST_NAME, SHIPOUT_CSV_KEYS.LAST_NAME, SHIPOUT_CSV_KEYS.EMAIL, SHIPOUT_CSV_KEYS.COUNTRY, SHIPOUT_CSV_KEYS.ADDRESS, SHIPOUT_CSV_KEYS.UNIT, SHIPOUT_CSV_KEYS.CITY, SHIPOUT_CSV_KEYS.STATE, SHIPOUT_CSV_KEYS.ZIP];
export let SHIPOUT_CSV_KEYS_ADDED = /*#__PURE__*/function (SHIPOUT_CSV_KEYS_ADDED) {
  SHIPOUT_CSV_KEYS_ADDED["STATUS"] = "status";
  SHIPOUT_CSV_KEYS_ADDED["PICK_AND_PACK_PRICE"] = "pickAndPackPrice";
  SHIPOUT_CSV_KEYS_ADDED["DISCOUNT"] = "discount";
  SHIPOUT_CSV_KEYS_ADDED["DUTIES_AND_TAXES"] = "dutiesAndTaxes";
  SHIPOUT_CSV_KEYS_ADDED["TAXES"] = "taxes";
  return SHIPOUT_CSV_KEYS_ADDED;
}({});
export let SHIPMENT_CSV_KEYS = /*#__PURE__*/function (SHIPMENT_CSV_KEYS) {
  SHIPMENT_CSV_KEYS["SHIPMENT_PRICE"] = "shipmentPrice";
  SHIPMENT_CSV_KEYS["SHIPPED_AT"] = "shippedAt";
  return SHIPMENT_CSV_KEYS;
}({});
export let TRACKING_INFO_CSV_KEYS = /*#__PURE__*/function (TRACKING_INFO_CSV_KEYS) {
  TRACKING_INFO_CSV_KEYS["POSTAL_SERVICE"] = "postalService";
  TRACKING_INFO_CSV_KEYS["TRACKING_NUMBER"] = "trackingNumber";
  return TRACKING_INFO_CSV_KEYS;
}({});
export const TRACKING_INFO_CSV_KEYS_SEQUENCE = [TRACKING_INFO_CSV_KEYS.POSTAL_SERVICE, TRACKING_INFO_CSV_KEYS.TRACKING_NUMBER];
export const SHIPOUT_CSV_HEADERS = {
  [SHIPOUT_CSV_KEYS.FIRST_NAME]: 'First Name',
  [SHIPOUT_CSV_KEYS.LAST_NAME]: 'Last Name',
  [SHIPOUT_CSV_KEYS.EMAIL]: 'Email',
  [SHIPOUT_CSV_KEYS.COUNTRY]: 'Country',
  [SHIPOUT_CSV_KEYS.STATE]: 'State',
  [SHIPOUT_CSV_KEYS.CITY]: 'City',
  [SHIPOUT_CSV_KEYS.ADDRESS]: 'Address',
  [SHIPOUT_CSV_KEYS.UNIT]: 'Unit (Optional)',
  [SHIPOUT_CSV_KEYS.ZIP]: 'Zip',
  [SHIPOUT_CSV_KEYS.PHONE]: 'Phone number (mandatory for overseas)'
};
export const SHIPOUT_SHIPMENT_DATA_CSV_HEADERS = {
  [SHIPOUT_CSV_KEYS_ADDED.STATUS]: 'Status',
  [SHIPMENT_CSV_KEYS.SHIPMENT_PRICE]: 'Shipment Cost',
  [SHIPOUT_CSV_KEYS_ADDED.DUTIES_AND_TAXES]: 'Duties and Taxes',
  [SHIPOUT_CSV_KEYS_ADDED.TAXES]: 'Taxes',
  [SHIPOUT_CSV_KEYS_ADDED.PICK_AND_PACK_PRICE]: 'Pick and Pack Fees',
  [SHIPOUT_CSV_KEYS_ADDED.DISCOUNT]: 'Discount',
  [SHIPMENT_CSV_KEYS.SHIPPED_AT]: 'Shipped Date',
  [TRACKING_INFO_CSV_KEYS.POSTAL_SERVICE]: 'Postal Service',
  [TRACKING_INFO_CSV_KEYS.TRACKING_NUMBER]: 'Tracking Number'
};
export const SHIPOUT_SHIPMENT_DATA_CSV_HEADERS_SEQUENCE = [SHIPOUT_CSV_HEADERS[SHIPOUT_CSV_KEYS.FIRST_NAME], SHIPOUT_CSV_HEADERS[SHIPOUT_CSV_KEYS.LAST_NAME], SHIPOUT_CSV_HEADERS[SHIPOUT_CSV_KEYS.EMAIL], SHIPOUT_CSV_HEADERS[SHIPOUT_CSV_KEYS.COUNTRY], SHIPOUT_CSV_HEADERS[SHIPOUT_CSV_KEYS.ADDRESS], SHIPOUT_CSV_HEADERS[SHIPOUT_CSV_KEYS.UNIT], SHIPOUT_CSV_HEADERS[SHIPOUT_CSV_KEYS.CITY], SHIPOUT_CSV_HEADERS[SHIPOUT_CSV_KEYS.STATE], SHIPOUT_CSV_HEADERS[SHIPOUT_CSV_KEYS.ZIP], SHIPOUT_SHIPMENT_DATA_CSV_HEADERS[SHIPOUT_CSV_KEYS_ADDED.STATUS], SHIPOUT_SHIPMENT_DATA_CSV_HEADERS[SHIPMENT_CSV_KEYS.SHIPMENT_PRICE], SHIPOUT_SHIPMENT_DATA_CSV_HEADERS[SHIPOUT_CSV_KEYS_ADDED.PICK_AND_PACK_PRICE], SHIPOUT_SHIPMENT_DATA_CSV_HEADERS[SHIPMENT_CSV_KEYS.SHIPPED_AT], SHIPOUT_SHIPMENT_DATA_CSV_HEADERS[TRACKING_INFO_CSV_KEYS.POSTAL_SERVICE], SHIPOUT_SHIPMENT_DATA_CSV_HEADERS[TRACKING_INFO_CSV_KEYS.TRACKING_NUMBER]];
export const SHIPOUT_CSV_EXAMPLES = {
  [SHIPOUT_CSV_KEYS.FIRST_NAME]: 'John',
  [SHIPOUT_CSV_KEYS.LAST_NAME]: 'Doe',
  [SHIPOUT_CSV_KEYS.EMAIL]: 'test@email.com',
  [SHIPOUT_CSV_KEYS.COUNTRY]: COUNTRY_CODES.US,
  [SHIPOUT_CSV_KEYS.STATE]: 'DC',
  [SHIPOUT_CSV_KEYS.CITY]: 'Washington',
  [SHIPOUT_CSV_KEYS.ADDRESS]: '600 Independence Ave SW',
  [SHIPOUT_CSV_KEYS.UNIT]: '5',
  [SHIPOUT_CSV_KEYS.ZIP]: '20597',
  [SHIPOUT_CSV_KEYS.PHONE]: ''
};
export const SHIPOUT_CSV_EXAMPLES_OVERSEAS = {
  [SHIPOUT_CSV_KEYS.FIRST_NAME]: 'John',
  [SHIPOUT_CSV_KEYS.LAST_NAME]: 'Doe',
  [SHIPOUT_CSV_KEYS.EMAIL]: 'test@email.com',
  [SHIPOUT_CSV_KEYS.COUNTRY]: 'GB',
  [SHIPOUT_CSV_KEYS.STATE]: '',
  [SHIPOUT_CSV_KEYS.CITY]: 'London',
  [SHIPOUT_CSV_KEYS.ADDRESS]: '150 London Wall',
  [SHIPOUT_CSV_KEYS.UNIT]: '',
  [SHIPOUT_CSV_KEYS.ZIP]: 'EC2Y 5HN',
  [SHIPOUT_CSV_KEYS.PHONE]: '+44 1793 496 0824'
};
export let PRODUCT_LIST_TYPE = /*#__PURE__*/function (PRODUCT_LIST_TYPE) {
  PRODUCT_LIST_TYPE["IN_STORE"] = "IN_STORE";
  PRODUCT_LIST_TYPE["OUT_OF_STORE"] = "OUT_OF_STORE";
  PRODUCT_LIST_TYPE["INVENTORY"] = "INVENTORY";
  return PRODUCT_LIST_TYPE;
}({});
export let SHIPOUT_STEPS = /*#__PURE__*/function (SHIPOUT_STEPS) {
  SHIPOUT_STEPS[SHIPOUT_STEPS["CSV_UPLOAD"] = 0] = "CSV_UPLOAD";
  SHIPOUT_STEPS[SHIPOUT_STEPS["SHIPMENT_SETUP"] = 1] = "SHIPMENT_SETUP";
  SHIPOUT_STEPS[SHIPOUT_STEPS["PAYMENT"] = 2] = "PAYMENT";
  SHIPOUT_STEPS[SHIPOUT_STEPS["SUCCESS"] = 3] = "SUCCESS";
  return SHIPOUT_STEPS;
}({});
export let INVENTORY_MODES = /*#__PURE__*/function (INVENTORY_MODES) {
  INVENTORY_MODES["STORE"] = "STORE";
  INVENTORY_MODES["INVENTORY"] = "INVENTORY";
  return INVENTORY_MODES;
}({});
export let InventorySettingsTabs = /*#__PURE__*/function (InventorySettingsTabs) {
  InventorySettingsTabs[InventorySettingsTabs["approvalAndPermissions"] = 0] = "approvalAndPermissions";
  InventorySettingsTabs[InventorySettingsTabs["paymentMethods"] = 1] = "paymentMethods";
  return InventorySettingsTabs;
}({});
export let InventorySettingsPaymentWidget = /*#__PURE__*/function (InventorySettingsPaymentWidget) {
  InventorySettingsPaymentWidget[InventorySettingsPaymentWidget["editPaymentMethod"] = 0] = "editPaymentMethod";
  InventorySettingsPaymentWidget[InventorySettingsPaymentWidget["listPaymentMethods"] = 1] = "listPaymentMethods";
  return InventorySettingsPaymentWidget;
}({});
export const MAX_PRODUCTS_IN_DISTRIBUTION_TOOLTIP = 9;
export const CONFIRM_BUTTONS_ATTRIBUTES = {
  OK: 'Ok',
  CANCEL: 'Cancel'
};
export let SWAG_BUNDLE_ADDONS_TYPES = /*#__PURE__*/function (SWAG_BUNDLE_ADDONS_TYPES) {
  SWAG_BUNDLE_ADDONS_TYPES["NOTECARD"] = "NOTECARD";
  SWAG_BUNDLE_ADDONS_TYPES["PACKAGE"] = "PACKAGE";
  return SWAG_BUNDLE_ADDONS_TYPES;
}({});